module.exports = __webpack_public_path__ + "img/brand-05.5f8e04ee.png";